import pako from 'pako';
import { Buffer } from 'buffer';
import mergeCltStatus from './diffCltStatus';

const replayArchiveStatus = (response) => {
  const start = new Date().getTime();
  let originalSize = 0;
  let compressedSize = 0;
  const inflate = (encoded) => {
    const buffer = Buffer.from(encoded, 'base64');
    let output = pako.inflate(buffer, { to: 'string' });
    output = output.replaceAll('Infinity', -1);
    originalSize += output.length;
    compressedSize += buffer.length;
    return JSON.parse(output);
  };

  const diffs = response.diffs || [];
  const baseTick = response.tick == null ? null : Number(response.tick);
  let expectedTick = baseTick;
  diffs.forEach((entry) => {
    const diffTick = Number(entry.tick);
    if (expectedTick !== null && diffTick !== expectedTick + 1) {
      throw new Error('Invalid archived CLT status replay');
    }
    expectedTick = diffTick;
  });

  let ws = inflate(response.json);
  let tick = baseTick;
  let replayedDiffs = 0;

  diffs.forEach((entry) => {
    ws = mergeCltStatus(ws, inflate(entry.json));
    tick = Number(entry.tick);
    replayedDiffs += 1;
  });

  return {
    ...ws,
    cycleData: {
      ...(ws.cycleData || {}),
      tick: tick || 0,
      fullStatus: diffs.length === 0,
      replayedDiffs,
      inflateCycle: new Date().getTime() - start,
      originalSize,
      compressedSize,
      resolvedAt: response.resolvedAt,
      archiveModeStep: ws?.map?.globalSettings?.archiveIntervalStep || 60000
    }
  };
};

export default replayArchiveStatus;
